<template>
  <div>
    <van-nav-bar
      title="扫码配货"
      left-text="返回"
      right-text="完成"
      left-arrow
      @click-left="onClickLeft"
      @click-right="finishMaterialAllocation"
      fixed
    />
    <div class="psiConfirmCont"><div>
      <div style="display: flex;">
        <van-field
            v-model="inputBarcode"
            center
            clearable
            label=""
            ref="inputBarcode"
            placeholder="请输入条码"
        >
          <template #button>
            <van-button size="small" type="info" @click="scanBarcode"
            >确定</van-button
            >
          </template>
        </van-field>
      </div>
      <!--          <div style="width: 100%">-->
      <!--            <input style="width: 100%" type="text" placeholder="请输入条码" v-bind="inputBarcode" @keyup="scanBarcode">-->
      <!--          </div>-->
    </div>
    <div class="psiDetailCont">
      <van-list
          v-model="loading"
          :finished="finished"
          v-if="userId"
          @load="onLoad"
          finished-text="没有更多了"
      >
        <div v-for="item in list" class="card" :key="item.uuid">
          <template>
            <table class="layout">
              <tr>
                <td><span>商品编码：</span>{{ item.skuCode }}</td>
                <td width="20%" v-if="isUseSerialNumber === '11'">
                  <input type="text" disabled v-model="item.barcode" placeholder="请输入条码">
                </td>
                <td width="20%" v-if="isUseSerialNumber === '12'">
                  <input type="text" v-model="item.quantity" placeholder="请输入数量">
                </td>
              </tr>
              <tr>
                <td><span>商品名称：</span>{{ item.skuName }}</td>
                <td width="20%" v-if="isUseSerialNumber === '11'">
                  <input type="text" disabled v-model="item.binId" placeholder="暂无货位码">
                </td>
                <td width="20%" v-if="isUseSerialNumber === '12'">
                  <input type="text" v-model="item.binId" placeholder="请输入货位码">
                </td>
              </tr>
            </table>
          </template>
        </div>
      </van-list>
    </div>
      <div class="recordBox">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1;background: #1989fa;display: flex;align-items: center;color:white;height: 30px;padding: 0 10px;border-radius: 2px;font-size: 12px;">
            <span>已配数量:</span>
            {{ quantity }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Tab, Tabs, NavBar, Field, Button, List, PullRefresh, Toast} from "vant";
import electronicAllocationService from "../../service/electronicAllocationService";

export default {
  data() {
    return {
      selected: 0,
      type: "",
      skuId: "",
      skuCode: "",
      skuName: "",
      isUseSerialNumber: "11",
      inputBarcode: "",
      inputBarcodeSkuId: "",
      quantity: 0,
      shouldDistributeQuantity: 0,
      list: [],
      loading: false,
      showStartAllocation: false,
      showEndAllocation: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      fields:[],
      dictNames: "",
      showPosition: true
    };
  },
  mounted: async function() {

    this.type = this.$route.query.type;
    let that = this;
    document.onkeydown = function(event) {
      if (event.keyCode == 13) {
        that.scanBarcode();
      }
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
},
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    userName() {
      return this.$store.getters.getUserName;
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    openHostDetail(id){
      this.$router.push({path:"allocationDetail/allocationHostDetail/" + id})
    },
    openMaterialDetail(id){
      this.$router.push({path:"allocationDetail/allocationMaterialDetail/" + id})
    },
    async scanBarcode() {
      if (this.inputBarcode == "" || this.inputBarcode == undefined) {
        Toast.fail("条码不能为空");
        return;
      }
      let a = false;
      for (let i = 0; i < this.list.length; i++) {
        const element = this.list[i];
        if (this.inputBarcode == element.barcode) {
          a = true;
        }
      }

      if (a) {
        Toast.fail("当前列表条码重复,请重新填写!");
      } else {
        // 查询条码对应商品id
        let resp3 = await electronicAllocationService.getSkuIdByBarcode(this.inputBarcode);

        if (resp3.data.Status == "1" && resp3.data.Data) {
          this.inputBarcodeSkuId = resp3.data.Data;
        }
        let resp2 = await electronicAllocationService.getBinInfoByBarcode(this.inputBarcode);
        if (resp2.data.Status == "1" && resp2.data.Data) {
          for (let i = 0; i < this.list.length; i++) {
            const element = this.list[i];
            if (element.barcode == "" && element.skuId == this.inputBarcodeSkuId) {
              element.barcode = this.inputBarcode;
              element.binName = resp2.data.Data[0].binName;
              element.binId = resp2.data.Data[0].binName;
              this.quantity ++;
              break;
            }
          }
        } else {
          Toast.fail("没有查询到条码，或条码未入库");
          this.inputBarcode = "";
          this.inputBarcodeSkuId = "";
          this.$refs.inputBarcode.focus();
        }
      }
    },
    async finishMaterialAllocation(){
      // eslint-disable-next-line no-console
      console.log(this.list);
      let res = {};
      if (this.isUseSerialNumber==="11"){
        res = await electronicAllocationService.saveMaterialDetail(this.skuId, this.skuName, JSON.stringify(this.list),this.$route.params.detailId);
      }else{
        res = await electronicAllocationService.saveMaterialDetailForNotCode(this.skuId, this.skuName, JSON.stringify(this.list),this.$route.params.detailId);
      }
      if (res.data.Status === "1"){
        Toast.success("保存成功");
        this.$router.go(-1);
      }else{
        Toast.fail(res.data.Message);
      }
    },
    async onLoad() {
      this.loginUserId = this.userId;
      this.loginUserName = this.userName;
      let detailRowRes = await electronicAllocationService.getMaterialDetailDataById(this.$route.params.detailId);
      if (detailRowRes.data.Status === "1"){
        let data = detailRowRes.data.Data[0];
        this.skuId = data.skuId;
        this.shouldDistributeQuantity = data.shouldDistributeQuantity;
        this.isUseSerialNumber = data.isUseSerialNumber;
        this.skuName = data.skuName;
        this.skuCode = data.skuCode;
      }

      let materialList = [];
      let res = await electronicAllocationService.getMaterialDetailById(this.skuId, this.$route.params.detailId)
        if (res.data.Status === "1") {
          let data = res.data.Data;
          // 查询已配的配货条码
          for (let j = 0; j < data.length; j++) {
            materialList.push({
              uuid: data[j].uuid,
              barcode: data[j].barcode,
              creatorId: data[j].creatorId,
              creatorName: data[j].creatorName,
              binId: data[j].binId,
              binName: data[j].binId,
              quantity: data[j].quantity,
              skuId:data[j].skuId,
              skuName: data[j].skuName,
              skuCode: data[j].skuCode,
            });
          }
          // 未配条码的给空数据
          for (
              let j = data.length;
              j < this.shouldDistributeQuantity;
              j++
          ) {
            materialList.push({
              uuid: "detail" + j,
              barcode: "",
              creatorId: this.userId,
              creatorName: this.userName,
              binId: "",
              binName: "",
              skuId: this.skuId,
              quantity: "",
              skuName: this.skuName,
              skuCode: this.skuCode,
            });
          }
        }
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...materialList];
      this.finished = true;
    },
    created: async function () {
      let tabIndex = localStorage.getItem('allocationDetailTabIndex');
      if(tabIndex === undefined || tabIndex === null) {
        tabIndex = 0;
        this.selected = 0;
      }else {
        this.selected = parseInt(tabIndex);
      }
    },
    switchTab(tabIndex) {
      localStorage.setItem('allocationDetailTabIndex', tabIndex);
      window.scrollTo(0, 0);
      this.type = tabIndex;
      this.value = '';
      this.onRefresh();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    }
  },
};
</script>

<style scoped>
.psiConfirmCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}
.btnBox {
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
}
.psiDetailCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}
.hostStatus {
  background-color: #e2e3e2;
  text-align: center;
}
</style>
